module.exports = __webpack_public_path__ + "img/product-we-got-a-problem-01-8.287f8451.png";